// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"5d978ae1","877":"310f1615"}[chunkId] + ".chunk.js";
};